import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "scrollreveal";
import boyImage from "../../assets/join instructors ar.webp";
import girlImage from "../../assets/train yr team ar (3).webp";
import boyImageEN from "../../assets/join instructors en.webp";
import girlImageEN from "../../assets/train yr team en (3).webp";
import { useTranslation } from "react-i18next";
import styles from "./JoinUs.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function JoinUs() {
  const { i18n } = useTranslation();
  const imageRef = useRef(null);
  const sectionRef = useRef(null);
  const screenWidth = window.innerWidth;

  useEffect(() => {
    const sr = ScrollReveal();
    sr.reveal(imageRef.current, {
      duration: 900,
      distance: screenWidth < 768 ? "0px" : "70px",
      easing: "ease-in",
      origin: "right",
      reset: false,
    });
    sr.reveal(sectionRef.current, {
      duration: 900,
      distance: screenWidth < 768 ? "0px" : "70px",
      easing: "ease-in",
      origin: "left",
      reset: false,
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        className={`${styles.twoimages_mobile} d-flex justify-content-around p-4 gap-4`}
      >
        <Link to="/studio/#contactUsStudio" ref={imageRef}>
          <div>
            <LazyLoadImage src={i18n.language === "ar" ? boyImage : boyImageEN}
              className={styles.train_your_team1}
              alt="Join-us" />
          </div>
        </Link>
        <a
          href="https://business.eyouthlearning.com/"
          rel="noreferrer"
          target="_blank"
          ref={sectionRef}
        >
          <div>
            <LazyLoadImage src={i18n.language === "ar" ? girlImage : girlImageEN}
              className={styles.train_your_team2}
              alt="train your team" />
          </div>
        </a>
      </div>
    </>
  );
}
